module.exports = __webpack_public_path__ + "static/media/Arrow-down-bright-red.552a82c8.svg";